<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section
            class="q-px-lg container-clientCarrierPage full-width row"
          >
            <span v-if="elements.length == 1" class="col-12">
              <jt-dynamic-form
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
                @on-select-change="combo"
              />
            </span>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div
      class="row full-width q-col-gutter-lg justify-center q-py-lg"
      v-if="forms[0] && forms[0].buttons.length > 0"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm"
          ><translate>CLEAN</translate></q-btn
        >
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn class="full-width" color="info" @click="actionButton(button)">
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtSelect, JtDataGrid } from 'jtech-webcomps'
import { repository } from 'jtech'

const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'clientCarrierPage',
  components: { JtSelect, JtDataGrid },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
export default class ClientCarrierPage extends Vue {
  async combo (data) {
    const { selectedValue } = data

    if (selectedValue) {
      const param = { id: selectedValue }
      const { registros } = await repository.resolveDatatableModel(
        'clientGenerator.pesquisarById',
        param
      )

      delete registros[0].id
      delete registros[0].idAcaoGrid
      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
    } else {
      this.elements[0].dadosForm.generatorDocument = null
    }
  }

  get inputs () {
    this.elements[0].inputs.find(
      (input) => (input.model == 'carrier')
    ).type = 'carrier_search'
    return this.elements[0]?.inputs
  }

  async selections (data) {
    const {
      carrier,
      clientGenerator,
      generatorDocument, client

    } = this.elements[0].dadosForm

    if (data.carrier.idField) {
      const carriers = await this.getCarrier(carrier)
      const carrierVehicle = await this.getCarrierVehicle(carrier)
      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...carriers,
        ...carrierVehicle
      }
    } else {
      this.elements[0].dadosForm = {
        carrier,
        clientGenerator,
        generatorDocument
      }
    }
    const interfaceName = this.name
    this.loadComboClientGeneratorByClientAndCarrier(client, carrier, interfaceName)
    this.$forceUpdate()
  }

  async getCarrierVehicle (carrier) {
    const param = { carrier: carrier }
    const { registros } = await repository.resolveDatatableModel(
      'carrierVehicle.pesquisar',
      param
    )
    return { carrierVehicles: registros }
  }

  async getCarrier (carrier) {
    const param = { id: carrier }
    const { registros } = await repository.resolveDatatableModel(
      'carrier.pesquisarSelecao',
      param
    )
    delete registros[0].id

    delete registros[0].idAcaoGrid
    return registros[0]
  }

  async loadComboClientGeneratorByClientAndCarrier (client, carrier, interfaceName) {
    const action = interfaceName === 'Alterar' ? 'clientCarrier.alterar' : 'clientCarrier.gravar'
    const params = { client: client, carrier: carrier }
    const forms = await repository.resolveModel(action, params)
    this.elements[0].relacionamentos.clientGenerator = forms.relacionamentos.clientGenerator
  }
}
</script>
<style lang="stylus" scoped>
.container-clientCarrierPage{
  .dynamic-form #scroll-area{
    height: calc(60vh - 25px) !important;
  }

  @media only screen and (max-height: 900px) {
  .dynamic-form {
    #scroll-area {
      height: calc(47vh - 25px) !important;
    }
  }
}

@media only screen and (max-height: 850px) {
  .dynamic-form {
    #scroll-area {
      height: calc(50vh - 25px) !important;
    }
  }
}

@media only screen and (max-height: 800px) {
  .dynamic-form {
    #scroll-area {
      height: calc(55vh - 25px) !important;
    }
  }
}

@media only screen and (max-height: 765px) {
  .dynamic-form {
    #scroll-area {
      height: calc(60vh - 35px) !important;
    }
  }
}

@media only screen and (max-height: 650px) {
  .dynamic-form {
    #scroll-area {
      height: calc(65vh - 25px) !important;
    }
  }
}
 }
</style>
